__turbopack_context__.v({
  "header": "GreenSource-module__V-PEiW__header",
  "root": "GreenSource-module__V-PEiW__root",
  "source": "GreenSource-module__V-PEiW__source",
  "sources": "GreenSource-module__V-PEiW__sources",
});
